<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          Technical Negotiations By TNC
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i>Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <div class="overflow-x-auto">
    <p-table [value]="vendors" editMode="row" dataKey="id" #table>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name" class="col-name">
            <p-sortIcon field="name"></p-sortIcon>
            Vendor Name
            <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="address" class="col-address">
            <p-sortIcon field="address"></p-sortIcon>
            Vendor Address
            <p-columnFilter type="text" field="address" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="upload" class="col-upload">
            <p-sortIcon field="upload"></p-sortIcon>
            Upload Doc
            <p-columnFilter type="text" field="upload" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="status" class="col-status">
            <p-sortIcon field="status"></p-sortIcon>
            Qualification Status
            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
          </th>
          <th *ngIf="stepDetails?.can_edit">
            Actions
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="rowData">
          <td>{{ rowData.vendor.name }}</td>
          <td>{{ rowData.vendor.address }}</td>

          <td>
            <ng-container *ngIf="editing; else showFile">
              <input type="file" (change)="onFileUpload($event, rowData)" />
            </ng-container>
            <ng-template #showFile>
              <a *ngIf="rowData.file; else noFile" [href]="apiUrl + rowData.file" target="_blank" class="file-name">
                {{ getFileName(rowData.file) }}
              </a>
              <ng-template #noFile>
                No file
              </ng-template>
            </ng-template>
          </td>
          <td>
            <div *ngIf="editing; else viewMode" class="d-flex align-items-center gap-3">
              <div class="form-check form-check-inline mb-0">
                <p-radioButton 
                  name="status{{ ri }}" 
                  value="Qualify" 
                  [(ngModel)]="rowData.status" 
                  inputId="q{{ ri }}"
                  class="mx-2"
                  [disabled]="!(stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6))">
                </p-radioButton>
                <span class="form-check-label ms-1">Qualified</span>
              </div>

              <div class="form-check form-check-inline mb-0">
                <p-radioButton 
                  name="status{{ ri }}" 
                  value="Disqualify" 
                  [(ngModel)]="rowData.status" 
                  inputId="d{{ ri }}"
                  class="mx-2"
                  [disabled]="!(stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6))">
                </p-radioButton>
                <span class="form-check-label ms-1">Disqualified</span>
              </div>
            </div>

            <!-- View mode -->
            <ng-template #viewMode>
              <span [ngClass]="{
            'text-success': rowData.status === 'Qualify' || rowData.status === 'Qualified',
            'text-danger': rowData.status === 'Disqualify' || rowData.status === 'Disqualified'
          }">
                {{ rowData.status === 'Qualify' ? 'Qualified' :
                rowData.status === 'Disqualify' ? 'Disqualified' : rowData.status }}
              </span>
            </ng-template>
          </td>

          <td class="min-wid-150" *ngIf="stepDetails?.can_edit">
            <button *ngIf="!editing" type="button" class="btn btn-outline-primary btn-sm" (click)="table.initRowEdit(rowData)">
              ✏️
            </button>
            <button *ngIf="editing" type="button" class="btn btn-success btn-sm mx-2" (click)="onRowEditSave(rowData)">
              ✔
            </button>
            <button *ngIf="editing" type="button" class="btn btn-outline-danger btn-sm" (click)="table.cancelRowEdit(rowData)">
              ❌
            </button>
          </td>

        </tr>
      </ng-template>
    </p-table>

    <!-- Document Upload Section -->
    <div class="mt-4 mb-4">
      <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
    </div>
    
    <ng-container *ngIf="schemeType != 'makeI'">
      <form [formGroup]="JustificationForm">
        <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
          <label for="pdsTitle"><strong>• Justification</strong></label>
          <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>
      </form>
    </ng-container>
  </div>
</div>

